import React from 'react'
import { Container, Grid, Tooltip, Box } from '@mui/material'
import StageFormView from './StageFormView'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../../i18n/locales'
import moment from 'moment-timezone'
import { MemorizedParametersTable } from '../../../device-management/components/ViewDevice/ParametersTable'

const customKpi = LanguageStrings().ThermalIQStrings.KpiDetailsComponent
const notification = LanguageStrings().ThermalIQStrings.CreateCustomKpiComponent
const CreateCustomKPIStrings = LanguageStrings().ThermalIQStrings.CreateCustomKpiComponent

const commonStyles = {
  color: 'var(--typography-dark-base-default, #F0F0F0)',
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: 'Honeywell Sans Web',
  fontSize: '16px',
  fontStyle: 'normal',
  lineHeight: '24px'
}

interface KpiTabViewProps {
  viewKpiInfo?: boolean
  customKpiDetails: any
  alarmDetails: any
}
interface Option {
  value: string
  label: string
}

const KpiTabView: React.FC<KpiTabViewProps> = ({ viewKpiInfo = false, customKpiDetails, alarmDetails }) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const ViewDeviceStrings = LanguageStrings().DeviceManagementCollectionStrings.ViewDevice
  const typeOptions: Option[] = [
    { value: 'ACCUMULATOR', label: 'Accumulator' },
    { value: 'RATE', label: 'Rate' },
    { value: 'RISING_EDGE', label: 'Rising Edge' },
    { value: 'FALLING_EDGE', label: 'Falling Edge' },
    { value: 'DURATION', label: 'Duration' }
  ]
  const periodOptions: Option[] = [
    { value: 'NONE', label: 'None' },
    { value: 'TODAY', label: 'Today' },
    { value: 'YESTERDAY', label: 'Yesterday' },
    { value: 'THIS_HOUR', label: 'This Hour' },
    { value: 'LAST_HOUR', label: 'Last Hour' },
    { value: 'LAST_24_HOURS', label: 'Last 24 Hours' },
    { value: 'THIS_WEEK', label: 'This Week' },
    { value: 'LAST_WEEK', label: 'Last Week' },
    { value: 'THIS_MONTH', label: 'This Month' },
    { value: 'LAST_MONTH', label: 'Last Month' }
  ]
  const columns = [
    ViewDeviceStrings.LowerAlarm,
    ViewDeviceStrings.LowLimit,
    ViewDeviceStrings.Operator,
    ViewDeviceStrings.LowSeverity,
    ViewDeviceStrings.LowerColor,
    ViewDeviceStrings.LowerText,
    ViewDeviceStrings.LowerLabel,
    ViewDeviceStrings.HigherAlarm,
    ViewDeviceStrings.HighLimit,
    ViewDeviceStrings.Operator,
    ViewDeviceStrings.HigherSeverity,
    ViewDeviceStrings.HigherColor,
    ViewDeviceStrings.HigherText,
    ViewDeviceStrings.HigherLabel
  ]

  const getTotalizePeriod = (type: string): string => {
    const period = periodOptions.find(option => option.value === type)?.label
    return period ?? ''
  }
  const getTotalizeType = (type: string): string => {
    const period = typeOptions.find(option => option.value === type)?.label
    return period ?? ''
  }

  const getCalculatedName = (index: number): string => {
    if (index === 0) {
      return customKpiDetails.stage[index].calculated_name
    }
    return customKpiDetails.stage[index - 1].calculated_name
  }

  const getStageValue = (index: number): number | null => {
    if (index === 0) {
      return customKpiDetails.stage[index].stage_value
    }
    return customKpiDetails.stage[index - 1].stage_value
  }

  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 15) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 15)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  const renderKpiInformation = (): JSX.Element => {
    return (
      <Grid container direction="row" style={{ marginTop: '10px', marginLeft: '15px' }}>
        <Grid item xs={12} sm={6} md={3} lg={3} style={{ marginTop: '30px' }}>
          <Typography style={{ ...commonStyles, fontWeight: 500 }}>{notification.HigherLimitNotification}</Typography>
          <Typography style={{ ...commonStyles, fontWeight: 600 }}>{customKpiDetails?.higher_limit_notification}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3} style={{ marginTop: '30px', marginLeft: '5em' }}>
          <Typography style={{ ...commonStyles, fontWeight: 500 }}>{notification.LowerLimitNotification}</Typography>
          <Typography style={{ ...commonStyles, fontWeight: 600 }}>{customKpiDetails?.lower_limit_notification}</Typography>
        </Grid>
      </Grid>
    )
  }
  console.log('alarmDetails', customKpiDetails, alarmDetails)

  return (
    <Grid data-testid='create-kpi-tab'>
      <Grid container spacing={2} direction='row' sx={{ marginTop: '10px', marginBottom: '30px', marginLeft: '10px' }}>
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Typography style={{ ...commonStyles, fontWeight: 500 }}>{customKpi.KpiName}</Typography>
          <Typography style={{ ...commonStyles, fontWeight: 600 }}>{formatTextWithTooltip(customKpiDetails?.kpi_name)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Typography style={{ ...commonStyles, fontWeight: 500 }}>{customKpi.Remarks}</Typography>
          <Typography style={{ ...commonStyles, fontWeight: 600 }}>{formatTextWithTooltip(customKpiDetails?.kpi_description)}</Typography>
        </Grid>
        {
          customKpiDetails?.is_assetLevel === true
            ? (
                <>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.Site}</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>{formatTextWithTooltip(customKpiDetails?.stage[0].kpi_parameters[0].site_name)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.Asset}</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>{formatTextWithTooltip(customKpiDetails?.stage[0].kpi_parameters[0].asset_name)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.Unit}</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>{customKpiDetails?.unit}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.Status}</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>{customKpiDetails?.is_enabled === true ? 'Enabled' : 'Disabled'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.Frequency}</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>{customKpiDetails?.frequency} {CreateCustomKPIStrings.FrequencyUnit}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>Dashboard Text</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>
                      {customKpiDetails?.dashboard_text !== null && customKpiDetails?.dashboard_text !== undefined
                        ? Object.entries(customKpiDetails.dashboard_text)
                          .map(([key, value]) => `"${String(key)}": "${String(value)}"`)
                          .join(', ')
                        : '-'
                      }
                    </Typography>
                  </Grid>
                </>
              )
            : (
                <>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.DeviceType}</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>{formatTextWithTooltip(customKpiDetails?.device_type)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.DeviceModel}</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>{formatTextWithTooltip(customKpiDetails?.device_model)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.Unit}</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>
                      {customKpiDetails?.unit}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Typography style={{ ...commonStyles, fontWeight: 500 }}>Dashboard Text</Typography>
                    <Typography style={{ ...commonStyles, fontWeight: 600 }}>
                      {customKpiDetails?.dashboard_text != null && customKpiDetails?.dashboard_text !== undefined
                        ? Object.entries(customKpiDetails.dashboard_text)
                          .map(([key, value]) => `"${String(key)}": "${String(value)}"`)
                          .join(', ')
                        : '-'
                      }
                    </Typography>
                  </Grid>
                </>
              )
        }
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Typography style={{ ...commonStyles, fontWeight: 500 }}>{CreateCustomKPIStrings.UpdatedOn}</Typography>
          <Typography style={{ ...commonStyles, fontWeight: 600 }}>
            {customKpiDetails?.updated_at !== undefined && customKpiDetails?.updated_at !== null && customKpiDetails?.updated_at !== '' ? moment.utc(customKpiDetails?.updated_at).tz(userTimezone).format('hh:mm A, MMM DD YYYY') : '-'}
          </Typography>
        </Grid>
        {viewKpiInfo ? (renderKpiInformation()) : null }
      </Grid>
      <Grid sx={{ maxWidth: '75vw', maxHeight: '80vh', marginTop: '32px' }}>
        <Container maxWidth={false} sx={{ marginLeft: '12px', padding: '0px !important', display: 'flex', flexDirection: 'row', overflowX: 'auto', overflowY: 'auto', maxWidth: '100vw', '&::-webkit-scrollbar-thumb': { background: '#202020' } }}>
          {Array.from({ length: Number(customKpiDetails?.stage.length) + 1 }).map((_, index) => (
            <StageFormView
              data-testid='stage-form-view'
              key={index}
              index={index}
              stage={customKpiDetails?.stage[index] ?? undefined}
              calculatedName={getCalculatedName(index)}
              isAssetLevel={customKpiDetails?.is_assetLevel}
              scaleFator={customKpiDetails?.scale_factor}
              totalizePeriod={getTotalizePeriod(customKpiDetails?.totalize_period)}
              totalizeType={getTotalizeType(customKpiDetails?.totalizer_type)}
              getStageValue={getStageValue(index)}
            />
          ))}
        </Container>
      </Grid>

              {customKpiDetails?.is_assetLevel === true && Array.isArray(alarmDetails) && alarmDetails.length > 0 && (
                      <>
                      <Grid sx={{ marginLeft: '12px', marginTop: '24px' }} data-testid='alarm-table' className='assetLevelContainer'>
                        <Grid item xs={12} className="alarm-parameter-table" data-testid="alarm-parameter-table">
                        <Box
                          sx={{
                            display: 'block',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            backgroundColor: 'transparent',
                            padding: '1px 5px 5px 5px',
                            borderRadius: '8px',
                            color: '#f0f0f0',
                            marginTop: '20px',
                            width: '100%'
                          }}
                        >
                          <MemorizedParametersTable title="Alarm Configuration" className='alarmAssetLevel' columns={columns} rows={alarmDetails.map((res: any) => {
                            return [
                              res?.isLowerLimitAlarmEnabled === true ? 'Enabled' : 'Disabled',
                              res?.alarmLowerLimit ?? '-',
                              res?.lowerLimitOperator ?? '-',
                              res?.alarmLowerLimitSeverityLevel ?? '-',
                              res?.alarmLowerLimitColorName ?? '-',
                              res?.alarmLowerLimitStateText ?? '-',
                              res?.alarmLowerLimitLabelName ?? '-',
                              res?.isHigherLimitAlarmEnabled === true ? 'Enabled' : 'Disabled',
                              res?.alarmHigherLimit ?? '-',
                              res?.higherLimitOperator ?? '-',
                              res?.alarmHigherLimitSeverityLevel ?? '-',
                              res?.alarmHigherLimitColorName ?? '-',
                              res?.alarmHigherLimitStateText ?? '-',
                              res?.alarmHigherLimitLabelName ?? '-'
                            ]
                          })} />
                        </Box>
                        </Grid>
                      </Grid>
                      </>
              )}

    </Grid>
  )
}

export default KpiTabView
